var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7588 6.1982L20.9088 4.0022C20.7151 3.87787 20.5046 3.78208 20.2836 3.7178C20.0635 3.64657 19.8344 3.60697 19.6032 3.6002H11.4L12.3612 9.6002H19.6032C19.8 9.6002 20.046 9.5558 20.2824 9.4826C20.5188 9.4094 20.7468 9.3086 20.9076 9.1994L23.7576 7.001C23.9196 6.8918 24 6.7466 24 6.6002C24 6.4538 23.9196 6.3086 23.7588 6.1982ZM10.2 1.2002H9C8.84087 1.2002 8.68826 1.26341 8.57574 1.37593C8.46321 1.48845 8.4 1.64107 8.4 1.8002V6.0002H4.3968C4.1976 6.0002 3.9528 6.0446 3.7164 6.119C3.4788 6.191 3.252 6.2906 3.0912 6.4022L0.2412 8.5982C0.0792 8.7074 0 8.8538 0 9.0002C0 9.1454 0.0792 9.2906 0.2412 9.4022L3.0912 11.6006C3.252 11.7098 3.4788 11.8106 3.7164 11.8826C3.9528 11.9558 4.1976 12.0002 4.3968 12.0002H8.4V22.2002C8.4 22.3593 8.46321 22.5119 8.57574 22.6245C8.68826 22.737 8.84087 22.8002 9 22.8002H10.2C10.3591 22.8002 10.5117 22.737 10.6243 22.6245C10.7368 22.5119 10.8 22.3593 10.8 22.2002V1.8002C10.8 1.64107 10.7368 1.48845 10.6243 1.37593C10.5117 1.26341 10.3591 1.2002 10.2 1.2002Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.220f5099b5dfc74a9e21ce0938a4a491.svg";
export { ForwardRef as ReactComponent };